export default __webpack_public_path__ + "static/media/letpension-logo.a3f4de74.svg";